import { giveawayModuleIds, } from 'root/src/client/web/giveaway/descriptions/modules/moduleIds';
export const redeemRewardsModalModule = {
    [giveawayModuleIds.REDEEM_MODAL_MODULE_ID]: {
        moduleType: 'modal',
    },
};
